@if (heads$ | async; as heads) {
  @for (head of heads; track head; let i = $index) {
    <customer-org-tree-overview-item
      [head]="head"
      [level]="level()"
      [last]="heads.length - 1 === i"
      [lastParent]="lastParent()"
      [selectedEmployeeId]="selectedEmployeeId()"
      [openEmployeeInView]="openEmployeeInView()"
      [service]="service()"
      [seasonId]="seasonId()"
      (clickTreeItem)="itemSelect.emit()"></customer-org-tree-overview-item>
  }
}
